/* ==========================================
   JACK FERTILITY — Partner Landing Page JS
   Vanilla JS only. No dependencies.
   ========================================== */

(function () {
  'use strict';

  const form = document.getElementById('plp-contact-form');
  const successEl = document.getElementById('plp-form-success');
  if (!form) return;

  /* ---------- Smooth scroll for CTA links ---------- */
  document.querySelectorAll('a[href^="#partner-enquiry-form"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('partner-enquiry-form');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- URL parameter preselect ---------- */
  var urlParams = new URLSearchParams(window.location.search);
  var typeParam = urlParams.get('type');
  if (typeParam) {
    var typeMap = {
      'retail': 'Retailer / reseller',
      'practitioner': 'Wellness practitioner / coach',
      'employer': 'Employer / workplace wellness',
      'clinical': 'Healthcare provider / clinic',
      'research': 'Researcher / academic institution'
    };
    var selectEl = document.getElementById('plp-org-type');
    if (selectEl && typeMap[typeParam]) {
      selectEl.value = typeMap[typeParam];
    }
  }

  /* ---------- Validation ---------- */
  function validateField(field) {
    var parent = field.closest('.plp-form__field');
    if (!parent) return true;

    var isRequired = field.hasAttribute('required');
    var value = field.value.trim();
    var isValid = true;

    if (isRequired && !value) {
      isValid = false;
    }

    if (field.type === 'email' && value) {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailPattern.test(value);
    }

    if (field.tagName === 'SELECT' && isRequired) {
      isValid = value !== '';
    }

    if (isValid) {
      parent.classList.remove('plp-form__field--invalid');
      field.classList.remove('plp-form__input--error', 'plp-form__select--error', 'plp-form__textarea--error');
    } else {
      parent.classList.add('plp-form__field--invalid');
      var errorClass = 'plp-form__input--error';
      if (field.tagName === 'SELECT') errorClass = 'plp-form__select--error';
      if (field.tagName === 'TEXTAREA') errorClass = 'plp-form__textarea--error';
      field.classList.add(errorClass);
    }

    return isValid;
  }

  /* Validate on blur */
  form.querySelectorAll('input, select, textarea').forEach(function (field) {
    field.addEventListener('blur', function () {
      validateField(field);
    });
  });

  /* ---------- Honeypot check ---------- */
  function isHoneypotFilled() {
    var honeypot = document.getElementById('plp-website');
    return honeypot && honeypot.value.length > 0;
  }

  /* ---------- Form submission ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    /* Honeypot */
    if (isHoneypotFilled()) {
      /* Silently fail — bot detected */
      if (successEl) {
        form.style.display = 'none';
        successEl.style.display = 'block';
      }
      return;
    }

    /* Validate all required fields */
    var allValid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      if (!validateField(field)) {
        allValid = false;
      }
    });

    if (!allValid) {
      /* Scroll to first error */
      var firstError = form.querySelector('.plp-form__field--invalid');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    /* Show loading state */
    var btnText = form.querySelector('.plp-btn__text');
    var btnLoading = form.querySelector('.plp-btn__loading');
    var submitBtn = form.querySelector('button[type="submit"]');
    if (btnText) btnText.style.display = 'none';
    if (btnLoading) btnLoading.style.display = 'inline';
    if (submitBtn) submitBtn.disabled = true;

    /* Submit via fetch to Shopify contact form */
    var formData = new FormData(form);

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function () {
        /* Show success state */
        form.style.display = 'none';
        if (successEl) {
          successEl.style.display = 'block';
          successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      })
      .catch(function () {
        /* Fallback: submit normally if fetch fails */
        form.submit();
      });
  });
})();
